import { jsx as _jsx } from "react/jsx-runtime";
import { chakra } from '@chakra-ui/react';
import { usePrefersReducedMotion } from '../../lib/use-prefers-reduced-motion';
import { useAgentBlocksTextContext } from '../../text/agent-blocks-text-context';
/**
 * The running label: a lilac band sweeps across the words (a text gradient,
 * not a surface). Under reduced motion it becomes the fixed "En cours…",
 * since a frozen gradient would only read as odd colouring.
 */
export function TraceLabel({ label }) {
    const text = useAgentBlocksTextContext();
    const reduced = usePrefersReducedMotion();
    if (reduced) {
        return _jsx(chakra.span, { color: "agent.fgMuted", children: text.trace.runningFallback });
    }
    return (_jsx(chakra.span, { "data-shimmer": "", color: "transparent", bgImage: "linear-gradient(90deg, {colors.agent.fgMuted} 0%, {colors.agent.fgMuted} 35%, {colors.agent.accent} 50%, {colors.agent.fgMuted} 65%, {colors.agent.fgMuted} 100%)", bgSize: "200% 100%", animation: "agent-shimmer 1.6s linear infinite", css: { WebkitBackgroundClip: 'text', backgroundClip: 'text' }, _motionReduce: { animation: 'none' }, children: label }));
}
